"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .unit("ug/l")
    .precision(2)
    .min(0)
    .max(1000)
    .interpretation({ vocab: "htx", code: "psa" })
    .tag({ vocab: "snomed", code: "63476009" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
